import { render, staticRenderFns } from "./onePage.vue?vue&type=template&id=6c17d205&"
import script from "./onePage.vue?vue&type=script&lang=js&"
export * from "./onePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports